// extracted by mini-css-extract-plugin
export default {"wrapper":"vG-z","button":"wG-z","alternate":"xG-z","disabled":"yG-z","paymentWarning":"zG-z","fadeIn":"AG-z"};